export const version = '2.8.4';
//# sourceMappingURL=version.js.map